import {isInfoTag} from '../domain/Tag.model.ts';

const getTagClassName = (tag) => {
  if (tag.type === 'CombinableTag') return 'badge text-white';
  if (isInfoTag(tag)) return 'badge border border-primary text-primary';
  return 'badge border border-warning text-warning';
};

const getTagStyle = (tag) => {
  if (tag.type === 'CombinableTag') return { backgroundColor: '#f0541e' };
  return undefined;
};

export const TagListUI = ({ data }) => {
  const { tags } = data;
  return (
    <div className="d-flex flex-row align-items-center gap-1 flex-wrap">
      {
        tags.map((tag, index) => (
            <span key={index}
                  className={getTagClassName(tag)}
                  style={getTagStyle(tag)}>
              {tag.value}
            </span>
          )
        )
      }
    </div>
  );
};
